import { Component, OnInit, EventEmitter, ViewChild, Output, OnDestroy } from '@angular/core';
import { PhBhpObserveChartExportComponent } from '../ph-bhp-observe-chart-export/ph-bhp-observe-chart-export.component';
import { Router } from '@angular/router';
import { PhBhpPdfComplianceComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-pdf-compliance/ph-bhp-pdf-compliance.component';
import { PhBhpFilterComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-filter/ph-bhp-filter.component';
import { Subscription } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { PHBHPFeaturePackageEvaluationService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/public_api';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { fiveMomentsMap, asepticProcedures } from '../../../../ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-asepticprocedures.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { PHBHPFeaturePackageEvaluationFilterService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-feature-package-evaluationfilter.service';
import { Observation } from 'src/app/ObserveObservation/Models/Observation';
import { TranslationKeys } from 'ph-bhp-localization'

@Component({
  selector: 'lib-ph-bhp-observe-overviewindividualdata',
  templateUrl: './ph-bhp-observe-overviewindividualdata.component.html',
  styleUrls: ['./ph-bhp-observe-overviewindividualdata.component.css']
})
export class PhBhpObserveOverviewindividualdataComponent implements OnInit, OnDestroy {

  @Output() childData = new EventEmitter();
  @ViewChild('filter', { static: true }) filter: PhBhpFilterComponent;

  modalRef: BsModalRef;
  @ViewChild('delmodal') delmodal;
  deleteData;
  horizontalAction = true;
  asepticprocedures = asepticProcedures;
  isDesktop = true;
  gridGroupable = true;
  isSelectable = true;
  public gridTable: any;
  @ViewChild('gridTable', { static: false }) set content(content: any) {
    this.gridTable = content;
  };
  @ViewChild('deleteSelectionModal') deleteSelectionModal;
  gridData: Array<any>;
  userData;
  data;
  appName = 'MHS';
  //pageTitle = this.langData.translatetext("EVALUATION.OVERVIEW_INDIVIDUAL_DATA_1")
  pageTitle = 'EVALUATION.OVERVIEW_INDIVIDUAL_DATA_1';
  noDataFound: boolean = false;
  userSubscription: Subscription;
  pageInfo = {
    ofLabel: "GENERAL.OF",
    items: "EVALUATION.OBSERVATIONS",//'Observations',
    itemsPerPageLabel: "EVALUATION.PER_PAGE.OBSERVATIONS",//'Observations per page'
  };
  commentTranslations;
  lang;
  deleteSelectionText: string = '';

  public clickImageBtn = false;
  public clickExcelBtn = false;
  public clickDetailsExcelBtn = false;
  public clickPdfBtn = false;
  isUserFilterSetted: boolean = true;
  userHasFilter: any = true;

  actionItems: any = [
    { name: 'LAYOUT_MODULE.DELETE', imgSrc: 'assets/ph-bhp-layout/svg/icon-delete.svg', onClick: (dataItem) => { this.openDeleteModal(this.delmodal, dataItem) } },
  ];

  fields: Array<any> = [
    { 'field': 'observeObservationID', 'title': 'EVALUATION.OVERVIEW.TABLE.OBSERVE_CODE', },
    { 'field': 'createdDateTime', 'title': 'EVALUATION.OVERVIEW.TABLE.DATETIME', },
    { 'field': 'institutionName', 'title': 'EVALUATION.OVERVIEW.TABLE.GROUP_INSTITUTIONS' },
    { 'field': 'departmentName', 'title': 'EVALUATION.OVERVIEW.TABLE.WARD_DEPT', },
    { 'field': 'professsionalCategoryName', 'title': 'EVALUATION.PROFESSIONAL_CATEGORY' },
    { 'field': 'professionalSubCategoryName', 'title': 'EVALUATION.OVERVIEW.TABLE.PROF_SUBCAT', },
    { 'field': 'observation', 'title': 'EVALUATION.OVERVIEW.TABLE.INDICATION', },
    { 'field': 'observedQuota', 'title': 'EVALUATION.ASEPTIC_TASKS_TABLE', },
    { 'field': 'observedQuota_action', 'title': 'EVALUATION.OVERVIEW.TABLE.OBSERVE_ACTION', },
    { 'field': 'observeComments', 'title': 'EVALUATION.COMMENTS', },
    { 'field': 'createdByName', 'title': 'OBSERVATION.CREATED_BY', }
  ];
  observationDetailsExcelFields: Array<any> = [
    {
      'field': 'observeObservationID',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.ObservationID
    },
    {
      'field': 'createdDateTime',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.Time,
      'format': (value) => {
        // HHP-3163 - Fixing date format for PT
        if (this.lang === 'pt') {
          const cleanedValue = value.replace(/\n|\|/g, ' ').trim();
          const parts = cleanedValue.split(/\s+/);
          const datePart = parts[0];
          const timePart = parts[1];
          const [day, month, year] = datePart.split('/');
          const formattedDate = `${year}-${month}-${day}T${timePart}`;

          const date = this.layoutService.convertUTCStingToLocalDate(new Date(formattedDate));
          const dayFormatted = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
          const monthFormatted = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
          const yearFormatted = date.getFullYear();
          const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
          const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
          const second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
          return `${dayFormatted}.${monthFormatted}.${yearFormatted} ${hours}:${minutes}:${second}`;
        } else {
          return value;
        }
      }
    },
    {
      'field': 'wardName',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.Wards,
      "format": (value) => {
        return this.layoutService.translateText(value)
      }
    },
    {
      'field': 'departmentName',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.Departments,
      "format": (value) => {
        return this.layoutService.translateText(value)
      }
    },
    {
      'field': 'professsionalCategoryName',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.ProfessionalCategory,
      'format': (value) => {
        return this.layoutService.translateText(value);
      }
    },
    {
      'field': 'professionalSubCategoryName',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.ProfessionalSubcategory,
      'format': (value) => {
        return value != null ? this.layoutService.translateText(value) : '';
      }
    },
    { //This description column is a column present in Observe v2 Individual data excel export, but its always hardcoded to 1.
      //Beside, there's no description property in Observe v2/v3 DB schemas.
      //TODO: Consider removing this column for v3 export as it seems totally useless
      'field': 'description',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.Description,
      'format': () => {
        return 1
      }
    },
    {
      'field': 'beforeTouchingPatient',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.BeforePatientContact,
      'format': (value) => {
        return this.boolToChar(value)
      }
    },
    {
      'field': 'beforeAsepticProcdures',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.BeforeAsepticTask,
      'format': (value) => {
        return this.boolToChar(value)
      }
    },
    {
      'field': 'afterBodyFluidExposure',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.AfterBodyFluidExposure,
      'format': (value) => {
        return this.boolToChar(value)
      }
    },
    {
      'field': 'afterTouchingPatient',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.AfterPatientContact,
      'format': (value) => {
        return this.boolToChar(value)
      }
    },
    {
      'field': 'afterTouchingPatientSurroundings',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.AfterPatientSurroundings,
      'format': (value) => {
        return this.boolToChar(value)
      }
    },
    {
      'field': 'handWash',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.HandWash,
      'format': (value) => {
        return this.boolToChar(value)
      }
    },
    {
      'field': 'handRub',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.HandRub,
      'format': (value) => {
        return this.boolToChar(value)
      }
    },
    {
      'field': 'missed',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.Missed,
      'format': (value) => {
        return this.boolToChar(value)
      }
    },
    {
      'field': 'gloves',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.Gloves,
      'format': (value) => {
        return this.boolToChar(value)
      }
    },
    {
      'field': 'compliant',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.Compliant,
      'format': (value) => {
        return this.boolToChar(value)
      }
    },
    {
      'field': 'beforeTouchingPatient',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.BeforePatientContact,
      'format': (value, row) => {
        return this.formatValueWithMissedDisinfection(value, row);
      }
    },
    {
      'field': 'beforeAsepticProcdures',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.BeforeAsepticTask,
      'format': (value, row) => {
        return this.formatValueWithMissedDisinfection(value, row);
      }
    },
    {
      'field': 'afterBodyFluidExposure',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.AfterBodyFluidExposure,
      'format': (value, row) => {
        return this.formatValueWithMissedDisinfection(value, row);
      }
    },
    {
      'field': 'afterTouchingPatient',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.AfterPatientContact,
      'format': (value, row) => {
        return this.formatValueWithMissedDisinfection(value, row);
      }
    },
    {
      'field': 'afterTouchingPatientSurroundings',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.AfterPatientSurroundings,
      'format': (value, row) => {
        return this.formatValueWithMissedDisinfection(value, row);
      }
    },
    {
      'field': 'observedCount',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.AmountPeopleObserved,
    },
    {
      'field': 'institutionName',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.Institution
    },
    {
      'field': 'observeComments',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.Comment,
      'format': value => {
        if (value && value.indexOf("##") > -1) {
          let comments = value.split("##");
          let final: string = "";
          comments.forEach((element) => {
            final = final + this.layoutService.translateText(element) + ", ";
          });
          let result = final.slice(0, -2);
          return result;
        }
        else {
          return this.layoutService.translateText(value);
        }
      }
    },
    {
      'field': 'asepticActionId',
      'title': TranslationKeys.Evaluation.ObserveIndividualDataExportColumns.AsepticTaskAssignment,
      "format": (value) => {
        var asepticprocedures = this.asepticproceduresValue(value)
        return asepticprocedures ? this.layoutService.translateText(this.asepticproceduresValue(value)) : null;
      }
    }
  ];

  isCallFor: string;
  translationKeys: typeof TranslationKeys = TranslationKeys
  evaluationLoaded: boolean = false;
  inEvaluation: boolean = false;
  isEvaluationTable: boolean = true;

  constructor(
    private modalService: BsModalService,
    private router: Router,
    public appConfig: AppConfig,
    private evaluationService: PHBHPFeaturePackageEvaluationService,
    private evaluationFilterService: PHBHPFeaturePackageEvaluationFilterService,
    private layoutService: PHBHPLayoutPackageService,
  ) { }


  ngOnInit() {
    this.lang = localStorage.getItem('selectedlanguage') || 'en'
    if (this.appConfig.userData) {
      this.onInitOverviewindividual();
    } else {
      this.userSubscription = this.appConfig.userSubject.asObservable().subscribe((res) => {
        this.onInitOverviewindividual();
        this.evaluate(true);
      });
    }

    this.layoutService.lang.subscribe((res) => {
      this.lang = res;
      this.onInitOverviewindividual();
      this.evaluate(true);
    });

    this.layoutService.showLoader = true;
    this.evaluationService.getUserHasObserveEvaluationFilter(this.appConfig.userData.userId, 'ObserveIndividualOverView').subscribe((userHasFilter: any) => {
      this.isUserFilterSetted = true;
      this.userHasFilter = userHasFilter;
      if (!this.userHasFilter) {
        this.noDataFound = true;
        this.filter.showFilter(true);
        // Inicializar filterName por defecto
        this.filter.setFilterNameFilter(this.layoutService.translateText('EVALUATION.FILTER') + ' 1', true);
      } else {
        // Propagar filterName del backend antes de evaluar
        const userFilterData = JSON.parse(this.userHasFilter.filterList);
        if (userFilterData && userFilterData.Filter && userFilterData.Filter[0] && userFilterData.Filter[0].filterName) {
          this.filter.setFilterNameFilter(userFilterData.Filter[0].filterName, true);
        }
        setTimeout(() => {
          this.evaluate(true);
        }, 1000);
      }
    }, (error) => { }, () => { this.layoutService.showLoader = false; });
  }

  resetExportAs(value: 'image' | 'excel' | 'pdf' | 'observation') {
    switch (value) {
      case 'image':
        this.clickImageBtn = false;
        break;
      case 'excel':
        this.clickExcelBtn = false;
        break;
      case 'pdf':
        this.clickPdfBtn = false;
        break;
      case 'observation':
        this.clickDetailsExcelBtn = false;
        break;
    }
  }

  ngOnDestroy() {
    if (this.userSubscription)
      this.userSubscription.unsubscribe();
  }
  onInitOverviewindividual() {
    this.userData = this.appConfig.userData;
    if (this.appConfig.filterDetails.length > 0) {
      this.filter.roleId = this.userData.roleName.roleId;
      this.evaluationFilterService.setFilterValue(this.appConfig.filterDetails[0], this.filter);
    }

    this.evaluationService.getPredefinedCommentsTranslations().subscribe((res) => {
      this.commentTranslations = res;
    });
  }

  evaluate(complianceType = false) {
    this.evaluationLoaded = false;

    if(this.inEvaluation) return;
    this.inEvaluation = true;

    this.data = {
      filter: [{
        startDate: this.filter.range.start,
        endDate: this.filter.range.end,
        instutionIDs: "",
        departmentID: "",
        wardID: "",
        professionalCategoryID: "",
        subprofessionalCategoryID: "",
        countryID: 0,
        filterName: this.filter.filterName || this.layoutService.translateText('EVALUATION.FILTER') + ' 1'
      }],

      isBenchMark: true,
      userId: this.userData.userId,
      isSavedFromEvaluation: true,
      roleId: this.userData.roleName.roleId
    }
    if (this.userData.roleName.roleId == 1 && this.filter.setCountry != 0) {
      this.data.filter[0].countryID = this.filter.setCountry.countryID
    }
    this.data.filter[0] = this.filter.assignData(this.data.filter[0]);
    this.layoutService.showLoader = true;
    this.isCallFor = "ObserveIndividualOverView ";
    if (complianceType) {
      this.isCallFor = "SavedData";
    }
    if (this.appConfig.dropdownChanged == "changed") {
      this.isCallFor = "empty";
    }
    this.evaluationService.getIndividualOverView(this.userData.userId, this.data, this.isCallFor,this.userData.country, this.lang,  complianceType)
    .subscribe(async res => {
      this.gridTable.clearSelection();
      this.appConfig.dropdownChanged = "";
      await this.addAdditionalColumns(res);
      this.layoutService.showLoader = false;
      if (res.observeEvaluationIndividualOverView) {
        if (res.observeEvaluationIndividualOverView[0] != null) {
          const that = this;
          this.gridData = res.observeEvaluationIndividualOverView.map(item => this.manageGrid(item, that));
          this.noDataFound = false;
        } else {
          this.noDataFound = true;
          this.gridData = [];
        }
      } else {
        this.noDataFound = true;
        this.gridData = [];
      }
      var filter = res.observeFilter;
      if (filter && complianceType) {
        // Inicializar filterName si no existe
        if (filter.filter[0] && (!filter.filter[0].filterName || filter.filter[0].filterName.trim() === "")) {
          filter.filter[0].filterName = this.layoutService.translateText('EVALUATION.FILTER') + ' 1';
        }
        
        let startDate = new Date(filter.filter[0].startDate);
        startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
        let endDate = new Date(filter.filter[0].endDate);
        endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
        this.filter.dateRange = [startDate, endDate];
        this.filter.selectDate();
        if (filter.filter[0].filterName) {
          this.filter.setFilterNameFilter(filter.filter[0].filterName, true);
        }
        this.filter.setCountryFilter(filter.filter[0].countryID, filter.filter[0].instutionIDs, filter.filter[0].wardID, true);
        this.filter.setInstitutionsByID(filter.filter[0].instutionIDs, true);
        if (this.filter.wardListLoaded && this.filter.wardListLoaded.length > 0) {
          this.filter.onWardChange(this.filter.wardListLoaded.find(x => x.wardID == filter.filter[0].wardID));
        }

        this.filter.setDepartmentFilter(filter.filter[0].departmentID, true);
        this.filter.setDepartmentTypeFilter(filter.filter[0].departmentTypeID, true);
        this.filter.setProfessionalCategory(filter.filter[0].professionalCategoryID, filter.filter[0].subprofessionalCategoryID, true);
      }
      this.evaluationLoaded = true;
      this.inEvaluation = false;
    });
  }

  async addAdditionalColumns(res: any) {
    var hasProfessionalSubCategoryEnabled = false;
    var hasAsepticSubTaskEnabled = false;
    var userRoleId = this.userData.roleName.roleId;
    this.fields = [
      { 'field': 'observeObservationID', 'title': 'EVALUATION.OVERVIEW.TABLE.OBSERVE_CODE', },
      { 'field': 'createdDateTime', 'title': 'EVALUATION.OVERVIEW.TABLE.DATETIME', },
      { 'field': 'institutionName', 'title': 'EVALUATION.OVERVIEW.TABLE.GROUP_INSTITUTIONS' },
      { 'field': 'departmentName', 'title': 'EVALUATION.OVERVIEW.TABLE.WARD_DEPT', },
      { 'field': 'professsionalCategoryName', 'title': 'EVALUATION.PROFESSIONAL_CATEGORY' },
      { 'field': 'observation', 'title': 'EVALUATION.OVERVIEW.TABLE.INDICATION', },
      { 'field': 'observedQuota_action', 'title': 'EVALUATION.OVERVIEW.TABLE.OBSERVE_ACTION', },
      { 'field': 'observeComments', 'title': 'EVALUATION.COMMENTS', },
      { 'field': 'createdByName', 'title': 'OBSERVATION.CREATED_BY' }
    ];

    if (res.observeEvaluationIndividualOverView == null || res.observeEvaluationIndividualOverView.length == 0) return;
    var institutionIds = Array.from(new Set(res.observeEvaluationIndividualOverView.map(item => item.institutionID)));
    for (let i = 0; i < institutionIds.length; i++) {
      var institutionId = institutionIds[i];
      var institutionConfig = await this.evaluationService.getConfigDetails(institutionId).first().toPromise();
      if (!hasProfessionalSubCategoryEnabled && institutionConfig.enableProfessionalSubCategory) {
        hasProfessionalSubCategoryEnabled = true;
      }

      if (!hasAsepticSubTaskEnabled && institutionConfig.enableAsepticSubTask) {
        hasAsepticSubTaskEnabled = true;
      }

      if (hasProfessionalSubCategoryEnabled && hasAsepticSubTaskEnabled) {
        break;
      }
    }

    var userRoleId = this.userData.roleName.roleId;
    if (hasProfessionalSubCategoryEnabled) {
      const professionalCategoryIndex = this.fields.findIndex(field => field.field === 'professsionalCategoryName') + 1;
      const professionalSubCategoryColumn = { 'field': 'professionalSubCategoryName', 'title': 'EVALUATION.OVERVIEW.TABLE.PROF_SUBCAT', };
      this.fields = [...this.fields.slice(0, professionalCategoryIndex), professionalSubCategoryColumn, ...this.fields.slice(professionalCategoryIndex)];
    }

    if (hasAsepticSubTaskEnabled) {
      const indicationIndex = this.fields.findIndex(field => field.field === 'observation') + 1;
      const asepticActionColumn = { 'field': 'observedQuota', 'title': 'EVALUATION.ASEPTIC_TASKS_TABLE', };
      this.fields = [...this.fields.slice(0, indicationIndex), asepticActionColumn, ...this.fields.slice(indicationIndex)];
    }

    if (userRoleId == 1 || userRoleId == 2) {
      const userNameColumn = { 'field': 'userName', 'title': 'EVALUATION.USER' };
      this.fields.push(userNameColumn);
    }

    if (userRoleId == 1) {
      const countryColumn = { 'field': 'countryName', 'title': 'AUTHORIZATION.COUNTRY' };
      this.fields.push(countryColumn);
    }
  }

  openDeleteModal(mode, data) {
    this.deleteData = data;
    this.modalRef = this.modalService.show(mode, Object.assign({}, { class: 'w-420' }));
  }
  delete() {
    this.evaluationService.deleteObserveObservation(this.deleteData.observeObservationID, this.userData.userId).subscribe(res => {
      this.evaluate(false);
    });
  }
  emitData(valve) {
    if (valve.value) {
      this.appConfig.filterDetails = valve.value;
      this.appConfig.dropdownChanged = "changed";
    } else {
      this.appConfig.filterDetails = [];
    }
    switch (valve.key) {
      case 'back': this.router.navigate(['evaluation/observeObservation/statistical']); break; // this._location.back();
      case 'overallCompliance': this.router.navigate(['evaluation/observe/overallCompliance']); break;
      case '5Moments': this.router.navigate(['evaluation/observe/fivemoments']); break;
      case 'individualData': this.router.navigate(['evaluation/observe/individualOverview']); break;
      case 'beforeAsepticProcedures': this.router.navigate(['evaluation/observe/StatisticsBeforeAsepticProcedures']); break;
      case 'comments': this.router.navigate(['evaluation/observe/comments']); break;
      case 'quota': this.router.navigate(['evaluation/observe/quota']); break;
      default: this.router.navigate(['evaluation/observeObservation/statistical']); break;
    }
  }

  asepticproceduresValue(assepticId) {
    if (assepticId && assepticId != 0)
      return this.asepticprocedures.find(res => res.id == assepticId).value;
    return null;
  }

  private boolToChar(boolean: boolean): string {
    return boolean ? 'Y' : 'N'
  }

  private formatValueWithMissedDisinfection(value: any, row: any): string {
    const missedDisinfection = row && row.cells ? row.cells[13].value : '';
    return `${this.boolToChar(value)}${missedDisinfection}`;
  }

  exportAs() {
    this.clickImageBtn = true;
  }

  excelDownload() {
    this.clickExcelBtn = true;
  }

  detailsExcelDownload() {
    this.clickDetailsExcelBtn = true;
  }

  downloadKendoPDF() {
    this.clickPdfBtn = true;
  }

  manageGrid(item, that) {

    var date = that.layoutService.convertUTCStingToLocalDate(item.createdDateTime);
    let lang = localStorage.getItem('selectedlanguage') || 'en'
    if (lang === 'en') {
      lang = 'en-GB';
    }
    item.createdDateTime = `${date.toLocaleDateString(lang, { month: '2-digit', day: '2-digit', year: 'numeric' })}
    | ${date.toLocaleTimeString(lang, { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })}`;

    item.departmentName = `${that.layoutService.translateText(item.wardName)} / ${that.layoutService.translateText(item.departmentName)}`;

    if (item.professionalSubCategoryName != null) {
      item.professionalSubCategoryName = `${that.layoutService.translateText(item.professsionalCategoryName)} / ${that.layoutService.translateText(item.professionalSubCategoryName)}`;
    } else {
      item.professionalSubCategoryName = `${that.layoutService.translateText(item.professsionalCategoryName)}`;
    }

    if (item.professsionalCategoryName) {
      item.professsionalCategoryName = `${that.layoutService.translateText(item.professsionalCategoryName)}`;
    }

    var action = [];
    if (item.beforeTouchingPatient)
      action.push(that.layoutService.translateText(that.translationKeys.Observation.BeforeTouching));
    if (item.beforeAsepticProcdures)
      action.push(that.layoutService.translateText(that.translationKeys.Observation.BeforeAseptic));
    if (item.afterBodyFluidExposure)
      action.push(that.layoutService.translateText(that.translationKeys.Observation.AfterBodyFluidExposure));
    if (item.afterTouchingPatient)
      action.push(that.layoutService.translateText(that.translationKeys.Observation.AfterTouchingAPatient));
    if (item.afterTouchingPatientSurroundings)
      action.push(that.layoutService.translateText(that.translationKeys.Observation.AfterTouchingPatientSurroundings));
    item.observation = action.join(", ");

    var asepticprocedures = that.asepticproceduresValue(item.asepticActionId)
    item.observedQuota = (asepticprocedures) ? that.layoutService.translateText(that.asepticproceduresValue(item.asepticActionId)) : null;

    var actionHand = []
    if (item.handRub)
      actionHand.push(that.layoutService.translateText(that.translationKeys.Observation.Handrub));
    if (item.handWash)
      actionHand.push(that.layoutService.translateText(that.translationKeys.Observation.Handwash));
    if (item.missed)
      actionHand.push(that.layoutService.translateText(that.translationKeys.Observation.Missed));
    if (item.gloves)
      actionHand.push(that.layoutService.translateText(that.translationKeys.Observation.Gloves));
    if (item.unavailable)
      actionHand.push(this.layoutService.translateText('OBSERVATION.UNAVAILABLE_LONG'));

    item.observedQuota_action = actionHand.join(", ");

    if (item.observeComments !== '' && item.observeComments !== null
      && item.observeComments !== undefined
      && new RegExp(that.commentTranslations.jewelleryComments.join("|")).test(item.observeComments)) {
      for (let i = 0; i < that.commentTranslations.jewelleryComments.length; i++) {
        item.observeComments = item.observeComments.replace(that.commentTranslations.jewelleryComments[i], that.layoutService.translateText('SOP_OBSERVATION.JEWELLERY_OR_WRIST_WATCH'))
      }
    }

    if (item.observeComments !== '' && item.observeComments !== null
      && item.observeComments !== undefined
      && new RegExp(that.commentTranslations.nailComments.join("|")).test(item.observeComments)) {
      for (let i = 0; i < that.commentTranslations.nailComments.length; i++) {
        item.observeComments = item.observeComments.replace(that.commentTranslations.nailComments[i], that.layoutService.translateText('SOP_OBSERVATION.ARTIFICIAL_NAILS_OR_VARNISH'))
      }
    }

    if (item.observeComments !== '' && item.observeComments !== null
      && item.observeComments !== undefined
      && new RegExp(that.commentTranslations.desinfectionComments.join("|")).test(item.observeComments)) {
      for (let i = 0; i < that.commentTranslations.desinfectionComments.length; i++) {
        item.observeComments = item.observeComments.replace(that.commentTranslations.desinfectionComments[i], that.layoutService.translateText('SOP_OBSERVATION.HAND_DISINFECTION_WRONG_EXECUTED'))
      }
    }

    if (item.observeComments !== '' && item.observeComments !== null
      && item.observeComments !== undefined
      && new RegExp(that.commentTranslations.antisepsisComments.join("|")).test(item.observeComments)) {
      for (let i = 0; i < that.commentTranslations.antisepsisComments.length; i++) {
        item.observeComments = item.observeComments.replace(that.commentTranslations.antisepsisComments[i], that.layoutService.translateText('SOP_OBSERVATION.SKIN_ANTISEPSIS_WRONG_EXECUTED'))
      }
    }

    if (item.observeComments !== '' && item.observeComments !== null
      && item.observeComments !== undefined
      && new RegExp(that.commentTranslations.processComments.join("|")).test(item.observeComments)) {
      for (let i = 0; i < that.commentTranslations.processComments.length; i++) {
        item.observeComments = item.observeComments.replace(that.commentTranslations.processComments[i], that.layoutService.translateText('SOP_OBSERVATION.PROCESS_INTERRUPTED'))
      }
    }

    if (item.observeComments !== '' && item.observeComments !== null
      && item.observeComments !== undefined
      && item.observeComments.indexOf("##") > -1) {
      let comments = item.observeComments.split("##");
      let final: string = "";
      comments.forEach((element) => {
        final = final + that.layoutService.translateText(element) + ", ";
      });
      let result = final.slice(0, -2);
      item.observeComments = result;
    }
    else {
      item.observeComments = that.layoutService.translateText(item.observeComments);
    }

    return item;
  }

  showDeleteSelectionModal() {
    var selectedRows = this.gridTable.getSelectedRows();
    this.deleteSelectionText = this.layoutService.translateText('ERROR_MESSAGES.CONFIRMATION.DELETE.RECORD_SELECTION');
    this.deleteSelectionText = this.deleteSelectionText.replace('{0}', selectedRows.length.toString());
    if (selectedRows.length > 0) {
      this.modalRef = this.modalService.show(this.deleteSelectionModal, Object.assign({}, { class: 'w-420' }));
    } else {
      this.layoutService.showWarning(this.layoutService.translateText('ERROR_MESSAGES.REQUIRED.NO_RECORD_SELECTED'));
    }
  }

  deleteSelection() {
    var selectedRows = this.gridTable.getSelectedRows();
    var observationIds = selectedRows.map(row => row.observeObservationID);
    this.layoutService.showLoader = true;
    this.evaluationService.deleteObserveObservations(observationIds, this.userData.userId).subscribe(res => {
      this.evaluate(false);
    }, error => { this.layoutService.showLoader = false; });
  }

  resetFilters() {
    this.filter.resetFilter();
    this.layoutService.showLoader = true;
    setTimeout(() => {
      this.evaluate(true);
    }, 1500);
  }

  onFilterSaved() {
    if (!this.userHasFilter) {
      this.layoutService.showLoader = true;
      this.userHasFilter = true;
      setTimeout(() => {
        this.evaluate(false);
      }, 1000);
    } else {
      this.evaluate(false);
    }
  }

  onRefreshClick(noDataFound: boolean) {
    if (noDataFound) {
      return;
    }

    this.evaluate(true);
  }

  openFilter() {
    this.filter.showFilter(true);
  }
}

